import ProductPOSPage from "../components/pages/products/ProductPOSPage";

const routes = [
    {
        path: "/products",
        element: <ProductPOSPage />
    }
];

export default routes;
